export const estadoCivil = [
  {
    id: 0,
    codigo: 'CASADO',
    name: 'Casado(a)'
  },
  {
    id: 1,
    codigo: 'DIVORCIADO',
    name: 'Divorciado(a)'
  },
  {
    id: 2,
    codigo: 'SEPARADO',
    name: 'Separado(a)'
  },
  {
    id: 3,
    codigo: 'SOLTEIRO',
    name: 'Solteiro(a)'
  },
  {
    id: 4,
    codigo: 'UNIAO_ESTAVEL',
    name: 'União Estável'
  },
  {
    id: 5,
    codigo: 'UNIAO_HOMOAFETIVA',
    name: 'União Homoafetiva'
  },
  {
    id: 6,
    codigo: 'VIUVO',
    name: 'Viúvo(a)'
  }
]

export const finalidade = [
  {
    id: 1,
    codigo: 'AGRICULTURA_FAMILIAR',
    name: 'Agricultura Familiar'
  },
  {
    id: 2,
    codigo: 'NENHUMA',
    name: 'Nenhuma'
  },
  {
    id: 3,
    codigo: 'REURB',
    name: 'TÍTULO DE DOAÇÃO URBANA - REURB-S',
    show: false
  }
]



// WEBPACK FOOTER //
// ./src/utils/select-objects.js